import { lazy } from 'react';

const Popconfirm = lazy(() => import('./Popconfirm'));

export { Popconfirm };
